import { render, staticRenderFns } from "./bavBar.vue?vue&type=template&id=57abd7f7&scoped=true&"
import script from "./bavBar.vue?vue&type=script&lang=js&"
export * from "./bavBar.vue?vue&type=script&lang=js&"
import style0 from "./bavBar.vue?vue&type=style&index=0&id=57abd7f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57abd7f7",
  null
  
)

export default component.exports